<div [appStoryblok]="_editable()">
  <app-product-carousel [products]="products$|async" eventSourceName="storyblok-carousel"></app-product-carousel>
</div>
@for (error of errors; track error) {
  <h3>{{error}}</h3>
}
